module.exports = __webpack_public_path__ + "static/media/IMG-20201016-WA0030.4f09ffa6.jpg";